export default {
  plvIA: {
    common: {
      enter: 'Please enter',
      tips: 'Tips',

      fetchFail: 'Fail to fetch data.',
      networkErr: 'Network Error.Please refresh and try again.',
      undefinedError: 'Unknown error',
      failFetchData: 'Error caught while getting data',

      // tips
      uploadSuccessfullyTips: 'Upload successfully',
      deleteSuccessfullyTips: 'Delete successfully',
      sentSuccessfullyTips: 'Send successfully',
      failedToSentTips: 'Failed to send',
      saveSuccessfullyTips: 'Save successfully',
      importSuccessTips: 'Apply successfully',
      copySuccessfullyTips: 'Copy successfully',
      copyUnsuccessfullyTips:
        'Copy failed.The browser does not support copy automatically.',
      editSuccessfullyTips: 'Successfully modified',
      confirmDiscardTips:
        'The previous operation was not saved.Discard existing data?',

      // buttons
      cancel: 'Cancel',
      confirm: 'Confirm',
      save: 'Save',
      delete: 'Delete',
      sent: 'Sent',

      // label
      privacy: 'Privacy agreement',

      sendText: 'Send',

    },

    datePicker: {
      startTime: 'Start date',
      endTime: 'End date',
      pickerTxt: 'Pick date'
    },

    answerCard: {
      statusOngoing: 'Ongoing',
      statusTerminated: 'Terminated',
      confirmDelTips: 'Operation cannot be undone.',
      confirmCoverTips:
        'Duplicate question bank name.Overwrite existing question bank?',
      cover: 'Overwrite',
      confirmDelQuesionTips: 'Question sheet will be deleted.',
      oneChoiceLabel: 'One-choice',
      multipleChoiceLabel: 'Multiple-choice',
      scoreLabel: 'Score',
      voteLabel: 'Vote',
      createQuestion: 'New',
      quickQuestion: 'Quick question sheet',
      timeLimit: 'Time limit',
      answerSheet: 'Question sheet',
      questionBank: 'Question bank',
      ongoingTips: 'Question sheet is ongoing, please stop first',
      defaultBankName: 'Default question bank',
      bankExistedTips:
        'The question bank already exists,upload is not allowed.',
      bankUsingNoCoverTips:
        'Current question bank is in use,unable to overwrite upload',
      bankName: 'Name',
      bankStatus: 'Status',
      operation: 'Operation',
      apply: 'Apply',
      download: 'Download',
      reupload: 'Re-upload',
      noContent: 'No more data',
      uploadBank: 'Upload question bank',
      downloadTemplate: 'Download template',
      inUsingStatus: 'Ongoing',
      notUsedStatus: 'Unused',
      templateErr: 'Template error',
      bankUsingCantDelTips: 'Current question bank is in use,cannot be deleted',
      defaultCantDelTips: 'Default question bank cannot be deleted',
      score: 'Points',
      person: '',
      totalSubmission: 'Total submission',
      correct: 'Correct',
      averageScore: 'Average score',
      stopRating: 'Stop',
      stopAnswer: 'Stop',
      remainingTime: 'Remaining time',
      submitted: 'Submitted count',
      submittedStatus: 'Submitted',
      send: 'Send',
      edit: 'Edit',
      sent: 'Sent',
      sendResults: 'Send results',
      sendAgain: 'Send again',
      continue: 'New',
      enterTimeLimit: 'Please enter time limit',
      questionType: 'Question type:',
      questionTitle: 'Title:',
      enterTitle: 'Please enter the title',
      questionOption: 'Option:',
      enterOption: 'Please enter the option',
      optionScore: 'Score:',
      enterScorePrompt: 'Please enter score prompt(Not required)',
      enterQuestionAnswer: 'Please select',
      enterOptions: 'Please enter options',
      create: 'New',
      import: 'Import',
      optionsCount: 'Options',
      seconds: 'seconds'
    },

    answerQuickly: {
      ranking: 'Ranking',
      nickname: 'Nickname',
      institution: 'Institution',
      responderTimeCost: 'Responder time cost',
      restart: 'Restart',
      seconds: 'seconds',
      secondsShorthand: 's',
      currently: 'Currently',
      respond: 'respond',
      endAutomaticallyTips:
        'After the countdown, the responder will end automatically',
      endNow: 'End now',
      responderTime: 'Responder time',
      cantEmptyTips: 'Responder time cannnot be empty',
      start: 'Start'
    },

    lottery: {
      requiredText: 'Required',
      userCustom: 'Custom',
      address: 'Address:',
      enterAddress: 'Please enter your delivery address',
      name: 'Name:',
      userName: 'Name',
      userPhone: 'Phone',
      customOption: 'Custom',
      addCollectOption: 'Add collection item',
      enterName: 'Please enter your name',
      phoneNum: 'Phone number:',
      enterPhoneNum: 'Please enter your phone number',
      exceedOnline:
        'The current online number may be less than the set number of winners, whether to continue?',
      allOnlineUsers: 'All audiences',
      missedUsers: 'No prize audiences',
      congratulationTips: 'Congratulations',
      copyList: 'Copy list',
      winnersList: 'List of winners',
      noNoneWon: 'No winner',
      allWon: 'All participant have won prizes',
      continue: 'New',
      end: 'Stop',
      prizeName: 'Name of prize:',
      enterPrizeName: 'Please enter a prize name',
      participatingUsers: 'Participant:',
      winnersNum: 'Number of winners:',
      enterPositiveInteger: 'Please enter a positive integer',
      presetWinning: 'Default winners:',
      quickSearch: 'Enter nickname for quick search',
      moreSettings: 'More settings',
      collection: 'Winners information collection:',
      userCollection: 'User information collection',
      addCustomOptions: 'Add custom options',
      custom: 'Custom option:',
      title: 'Title',
      enterDescription: 'Please enter your description',
      start: 'Start',
      exceedWinners: 'Default winners number exceeds set winners number',
      history: 'Record',
      referenceName: 'Refer name',
      grandPrize: 'The special prize',
      firstPrize: 'The first prize',
      secondPrize: 'The second prize',
      thirdPrize: 'The third prize',
      startLiveFirst: 'Start class first, and then start a draw',
      lotteryMode: 'Lottery Mode',
      luckyTime: 'Luck Time',
      closeLottery: 'Close',
      immediate: 'Immediate',
      timed: 'Timed',
      switchOldBranch: 'Switch to old version',
      switchNewBranch: 'Switch to New version',
      toast1: 'Set up to {t}',

      statusCancel: 'The cancel',
      back: 'back',

      createdSweepstakes: 'Created a sweepstakes?',
      selectActivity: 'selectActivity',
      reset: 'Reset',
      lotteryMethod: 'Draw conditions:',
      activityDuration: 'Activity Duration:',
      drawTime: 'Draw Time:',
      numberWinners: 'Number of winners:',
      theEnd: 'The End',
      inProgress: 'In progress',
      notStarted: 'Not Started',
      notTemplateList: 'No event created yet',
      activeOver: 'The event is over',
      viewResults: 'View Results',
      cancelDraw: 'Cancel the draw',
      continueDraw: 'Continue to draw',
      endDraw: 'End the draw',
      conditionNone: 'Unconditionally',
      conditionDuration: 'Viewing time',
      conditionInvite: 'Invite friends',
      lotteryingStatusTip1: 'Conditional and unconditional lottery draws are in progress, and draws are temporarily unavailable',
      lotteryingStatusTip2: 'Conditional lottery is in progress, only unconditional lottery can be initiated',
      lotteryingStatusTip3: 'There is an unconditional sweepstakes in progress, only conditional sweepstakes can be initiated',
      templateLotteryName: 'name',
      templatePrizeName: 'prize',
      templateDuration: 'duration',
      templateCondition: 'conditions',
      templateAmount: 'winners',
      templateHandle: 'operate',
      templateChoose: 'Choose',
      noRecord: 'No activity yet',
      noWinner: 'No winner list yet',

      privacyTips: 'After opening, the audience must agree with the privacy statement set by you to confirm to receive the prize.',
      pleaseEntryCollect: 'Please add information to collect',
    },

    notice: {
      addLink: 'Add a link',
      enterNotice: 'Please make your announcement here',
      publish: 'Send',
      publishNew: 'New',
      confirmDelTips: 'Unable to recover after deletion',
      publishSuccessfullyTips: 'Send successfully',
      linkAddr: 'Link',
      linkTxt: 'Text',
      defaultLinkAddr: 'Use link address by default',
      edit: 'Modify',
      add: 'Add'
    },

    questionnaire: {
      noAnswer: 'No correct answer for the current questionnaire.',
      titleNotEmptyTips: 'Survey name cannot be empty',
      titleMaxLenTips: 'Length of survey name cannot be more than',
      characters: 'characters',
      contentNotEmptyTips: 'Title cannot be empty',
      contentMaxLenTips: 'Title cannot exceed ',
      scoreNotEmptyTips: 'Score cannot be empty',
      enterAnswer: 'Please submit the answer of the question',
      optionContentNotEmptyTips: 'Option cannot be empty',
      optionContentMaxLenTips: 'Length of option content cannot be longer than',
      questionsNotEmptyTips: 'Survey content cannot be empty',
      confirmDiscardTips: 'Survey cannot be restored after discard.',
      score: 'Points',
      respond: 'Recycled',
      count: '',
      stop: 'Stop',
      edit: 'Edit',
      sendResult: 'Send results',
      publish: 'Send',
      republish: 'Send again',
      downloadResult: 'Down results',
      enterOptions: 'Please enter options',
      questionType: 'Question type:',
      oneChoiceLabel: 'One-choice',
      multipleChoiceLabel: 'Multiple-choice',
      qaLabel: 'Short-answer',
      required: 'Required',
      scoringQuestions: 'Score',
      enterTitle: 'Please enter question title',
      confirmDelTips: 'Operation cannot be undone.',
      name: 'Name:',
      enterName: 'Please enter the survey name',
      addQuestion: 'Add',
      discardEditing: 'Discard editing',
      notExceed: 'One survey cannot exceed',
      questionCount: 'questions',
      newQuestionnaire: 'New',
      downloadTemplate: 'Download template',
      discard: 'Confirm',
      continueEditing: 'Cancel',
      ongoingTips: 'A survey is currently in progress,please end it first.',
      toStop: 'Go end',
      notCreated: 'Survey not yet created',
      sent: 'Sent',
      terminated: 'Terminated',
      seconds: 'seconds',
      publishTips:
        'Stop and get results (default stop automatically after 72h)',
      person: '',
      totalSubmission: 'Total submission',
      noLive: 'Please start the live broadcast first, and then initiate a question',
      privacyTips: 'After opening, the audience must agree with the privacy statement set by you before uploading the questionnaire.'
    },

    checkIn: {
      startTips: 'It\'s now time to sign up !',
      onlineNum: 'Online number',
      person: '',
      checkInNum: 'Attendance',
      rate: 'Rate',
      clickToDownload: 'Download',
      nickname: 'Nickname',
      status: 'State',
      attendedList: 'Attended List',
      absentList: 'Absent List',
      noRecords: 'No record',
      backToHistory: 'Back to record',
      sendResult: 'Send results',
      close: 'Close',
      timeRange: 'Time limit',
      search: 'Search',
      downloadRecords: 'Download',
      checkedInTime: 'Time',
      checkedInNum: 'Number',
      checkedInRate: 'Rate',
      operation: 'Operation',
      detail: 'Details',
      noData: 'No data',
      enterTimeRange: 'Please select a time range to query the data',
      return: 'Return',
      seconds: 'seconds',
      secondsShorthand: 's',
      minutes: 'minutes',
      hours: 'hours',
      tips: 'Prompt',
      duration: 'Duration',
      historyRecords: 'Record',
      startCheckedIn: 'Start',
      currentlyPerson: 'The number of attendance ',
      stopCheckIn: 'End'
    },

    // 问答
    qa: {
      checkAll: 'View all',
      checkOnlyPrivate: 'Private chat',
      askLabel: 'Q:',
      answerLabel: 'A:',
      opHandleLater: 'Ignore',
      opCollapse: 'Hide',
      opReply: 'Reply',
      statusPrivate: ' (private)',
      sessionAll: 'All sessions',
      status0: 'Not replied',
      status1: 'Ignore',
      status10: 'Replied',
      statusAll: 'All',
      tipsLoading: 'Loading...',
      tipsNoData: 'No data~',
      tipsBottom: 'No more updates~',
      tipsMsgSent: 'Message sent',
      tipsParamsErr: 'Request parameter error',
      tipsNet5xx: 'An error occurred while requesting the server',
      plhReply: 'Please fill in your answer',
      chkPrivate: 'Private chat',
      opSend: 'Send'
    },

    timer: {
      timer: 'Timer',
      start: 'Start',
      revoke: 'Revoke',
      continue: 'Continue',
      pause: 'Pause',
      timeout: 'Timeout',
      timeoutLabelCan: '(Timeout)',
      timeoutLabelBeen: '(Timeout)'
    },

    enrollLottery: {
      address: 'Address:',
      enterAddress: 'Please enter your delivery address',
      name: 'Name:',
      enterName: 'Please enter your name',
      phoneNum: 'Phone number:',
      enterPhoneNum: 'Please enter your phone number',
      exceedOnline:
        'The current online number may be less than the set number of winners, whether to continue?',
      allOnlineUsers: 'All audiences',
      missedUsers: 'No prize audiences',
      congratulationTips: 'Congratulations',
      copyList: 'Copy list',
      winnersList: 'List of winners',
      noNoneWon: 'No winner',
      allWon: 'All participant have won prizes',
      continue: 'New',
      end: 'Stop',
      prizeName: 'Name of prize:',
      enterPrizeName: 'Please enter a prize name',
      participatingUsers: 'Participant:',
      winnersNum: 'Number of winners:',
      enterPositiveInteger: 'Please enter a positive integer',
      presetWinning: 'Default winners:',
      quickSearch: 'Enter nickname for quick search',
      moreSettings: 'More settings',
      collection: 'Winners information collection',
      userCollection: 'User information collection',
      addCustomOptions: 'Add custom options',
      custom: 'Custom option:',
      title: 'Title',
      enterDescription: 'Please enter your description',
      start: 'Start',
      exceedWinners: 'Default winners number exceeds set winners number',
      history: 'Record',
      referenceName: 'Refer name',
      grandPrize: 'The special prize',
      firstPrize: 'The first prize',
      secondPrize: 'The second prize',
      thirdPrize: 'The third prize',
      startLiveFirst: 'Start class first, and then start a draw',
      localList: 'Local List:',
      enrollList: 'Enroll List:',
      uploadList: 'Upload',
      changeList: 'Change',
      uploading: 'Uploading...',
      downloadTemplate: 'Download',
      enrollStart: 'Start:',
      enrollEnd: 'End:',
      autoEndLottery: 'auto end lottery',
      filterWinner: 'filter winners',
      save: 'save',
      cancel: 'cancel',
      stop: 'stop',
      deleteText: 'Are you sure you want to delete this record',
      stopText: 'Are you sure you want to terminate the draw',
      localListTitle: 'List management',
      enrollListTitle: 'Audience registration list',
      downloadList: 'Download list',
      enrollNoData: 'No data',
      return: 'Return',
      launching: 'Launching'
    },
    redpacket: {
      normalRedpacket: 'Ordinary red envelope',
      passwordRedpacket: 'Password red envelope',
      redpacketRain: 'Red envelope rain',
      redpacketPwd: 'password',
      enterRedpacketPwd: 'Enter Red envelope password',
      currently: 'Currently ',
      personOnline: 'person online',
      currentlyLuckPacket: 'Currently is lucky Red Envelope',
      currentlyEquallyPacket: 'Currently is equally divided red envelopes',
      changeEquallyPacket: 'Change to equally divided red envelope',
      changeLuckPacket: 'Change to lucky Red Envelope',
      putMoney: 'Put Money',
      putScore: 'Put Score',
      connectGM: 'Please contact customer service to activate this function',
      toast1: 'The maximum setting is {t} yuan',
      toast2: 'The maximum setting is {t}',
      pwdTipDefault: 'none',

      statusNoSend: 'Unissued',
      btnBack: 'Return',
      btnConfirm: 'Immediate release',
      sendSuccess: 'Red envelope issued successfully',
      preRedpacketMsg: 'Set in the background in advance',
      sendOtherRedpacket: 'Issue other red envelopes',
      preRedpacketTypeTable: 'Type',
      preRedpacketName: 'Name',
      preRedpacketType: 'Type:',
      preRedpacketAccount: 'Account:',
      preRedpacketQuantity: 'Quantity:',
      preRedpacketStatus: 'Status:',
      preRedpacketCoverText: 'Bless:',
      amountQuantity: 'Amount / quantity',
      sendMethod: 'Method',
      state: 'State',
      operation: 'Operation',
      luckyEnvelope: 'lucky red envelope',
      equallyEnvelope: 'equally divided red envelope',
      immediateRelease: 'Immediate release',
      countdownMinute: 'Countdown {minutes} minute(s)',
      sendBtn: 'Send',
      detail: 'Detail',
      returnText: 'Return',
      preRedEnvelopes: 'Red envelopes',
      preRedpacketUnissued: 'Unissued',
      preRedpacketAllotRandom: 'lucky red envelope',
      preRedpacketAllotAverage: 'equally divided red envelope',
      preYuan: 'RMB/',
      preYuan2: 'RMB',
      preGe: 'packet(s)',
      preGe1: 'packet(s)',
      preGe2: 'packet(s)',
      preExpiredTimeText: ', Expired at {date}',
      choosePreRedpacket: 'Choose Envelope',

      // 预设红包页面 弹窗title
      preRedpacketTitle: 'Select red envelope',
      // 发红包成功 弹窗title
      sendRedpacketSuccessTitle: 'Success',
      // 创建红包页 弹窗title
      createRedpacketTitle: 'Red envelopes',
      // 预设红包详情 弹窗title
      preRedpacketDetailTitle: 'Details',
      preRedpacketPwd: 'Envelope Password:',
      prePwdTip: 'Password Reminder:',

    },
    redpacketRain: {
      time: 'time',
      redpacketId: 'redpacketId',
      send: 'Send',
      account: 'Redpacket Account',
      handleFetch: 'Detail',

      plessQrcode: 'Pless use wechat',
      paySuccess: 'Pay Success',
      payFail: 'Pay Fail',

      luckyRedEnvelope: 'Random Amount',
      divideRedpackets: 'Identical Amount',
      total: 'Total',
      totalPoint: 'Total',
      cny: 'CNY',
      score: 'Score',
      atleast: 'The amount is greater than 1 yuan',
      atleastPoint: 'The amount is greater than 1 number',
      pleaseEntryMoney: 'Please Entry',
      unit: '￥',
      quantity: 'Quantity',
      enterNumber: 'Enter number',
      ge: 'number',
      coverText: 'Cover text',
      pwdTip: 'reminder',
      enterPwdTip: 'Enter Password reminder',
      bestWishes: 'Best wishes',
      putRedpacket: 'Prepare Red Packet',

      sendCash: 'Send Cash',
      sendPoint: 'Send Score',

      randomTip1:
        'If the amount is large, the progress of withdrawal may be affected. Please contact the sales staff.',
      randomTip2:
        'You can only grab the red envelope within WeChat, and the refund will be initiated within 24 hours for the unclaimed red envelope.',
      randomTip3:
        'A transaction commission of 2% shall be paid to WeChat and banks.',
      randomTip4:
        'The probability of the audience getting the red envelope is not 100%, so they need to fight luck to get it.',

      identicalRainTip1:
        'When the amount is large, it may affect the withdrawal progress of the audience. Please contact the sales department',
      identicalRainTip2:
        ' the red bag can only be carried out in wechat. The undelivered red bag will be refunded 24 hours later',
      identicalRainTip3:
        ' 2% of transaction handling fee shall be paid to wechat and bank',
      identicalRainTip4:
        'the probability of the audience getting red envelopes is not 100%, which requires luck',

      identicalOtherTip1:
        'When the amount is large, it may affect the progress of the audience\'s withdrawal, please contact sales.',
      identicalOtherTip2:
        'Grabbing red envelopes can only be done within WeChat. Unclaimed red envelopes will be refunded within 24 hours.',
      identicalOtherTip3: ' A 2% transaction fee must be paid to WeChat and the bank.',
      identicalOtherTip4: 'The probability of the audience getting the red envelope is not 100%, and you need to work hard to get it.',

      pointTip1: 'After the user receives the red envelope, there may be a delay in the arrival of the red envelope. Please consult the administrator for the specific delay time.',

      taost1: 'The total amount should not be more than ',
      taost2: 'The total amount should not be less than ',
      taost3: 'Failed to insert money into the red envelope. Please try again',
      toast4: 'The minimum split amount is greater than or equal to {t} yuan',
      toast5: 'Currently available points are ',
      toast6: 'Redpack count should less than score available',
      toast7: 'The total score should not be more than ',
      toast8: 'The minimum split score is greater than or equal to {t} ',
      taost9: 'The total score should not be more than ',

      sendSuccess: 'Successfully',

      handleFareTip1: 'Actual amount including 2% handling charge Actual ',
      handleFareTip2: 'amount is equal to payable amount /0.98',

      singlePrice: 'Amount',
      singlePoint: 'Amount',
      singlePricePla: '',
      plesseEntry: '',
      ping: '',
      deng: '',
      countDown: 'Countdown:',
      receiveTime: 'minutes after the countdown',
      distribution: 'Method:',
      waitDelay: 'Please wait for the countdown to end',
      beforeGet: 'minutes after the countdown',
      immediate: 'Immediate release',
      countdownDistribution: 'Countdown distribution',
      seeExample: 'See Example',
      watchPageExample: 'Watch page example',
      minDelayLimit: 'The minimum countdown is ',
      maxDelayLimit: 'The countdown is up to ',
      minutes: 'minutes'
    }
  }
};
